import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CalendarDays } from "lucide-react";
import api from "@/lib/api";
import { Loader } from "@/components/public/Bits";
import { MediaDisplay } from "@/components/MediaDisplay";
import { sanitizeHtml } from "@/lib/sanitize";

export default function NewsDetail() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/public/news/${id}`).then((r) => setItem(r.data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-24 text-center">
        <h1 className="font-serif text-3xl font-bold text-ukf-ink">Article not found</h1>
        <Link to="/news" className="mt-4 inline-block text-ukf-red hover:underline">← Back to News</Link>
      </div>
    );
  }
  if (!item) return <Loader />;

  return (
    <article className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8" data-testid="news-detail">
      <Link to="/news" data-testid="news-back-link" className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 transition-colors hover:text-ukf-red">
        <ArrowLeft className="h-4 w-4" /> All News
      </Link>
      <p className="mt-8 flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-wider text-ukf-gold-dark">
        <CalendarDays className="h-4 w-4" />
        {new Date(item.date).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}
      </p>
      <h1 className="mt-3 pt-2 font-serif text-4xl font-bold leading-[1.3] tracking-tight text-ukf-ink">{item.title}</h1>
      <div className="ukf-gold-rule mt-5" />
      {item.content?.trim() && (
        <div className="rte-content mt-8" dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.content) }} />
      )}
      {item.media?.length > 0 && (
        <div className="mt-10 border-t border-slate-200 pt-8">
          <h2 className="mb-5 font-mono text-xs font-semibold uppercase tracking-wider text-ukf-red">Attachments</h2>
          <MediaDisplay media={item.media} />
        </div>
      )}
    </article>
  );
}
